import moment from 'moment'
import { ISeedAccountancyDataCreateInput, ISeedDataCreateInput } from '@cbgms/api'

type SeedDataCreateInputType = Omit<ISeedDataCreateInput, 'ShopID' | 'CompanyUUID'>
type SeedDataAccountancyCreateInputType = Omit<ISeedAccountancyDataCreateInput, 'ShopID' | 'CompanyUUID'>

export const DefaultSeedDataCreateInput: SeedDataCreateInputType = {
  AmountOfPrivateAccounts: 75,
  AmountOfBusinessAccounts: 75,
  TotalAmountOfVehicles: 150,
  AmountOfVehiclesLinkedToAccount: 100,
  AmountOfRDWVehicles: 30,
  AmountOfROBVehicles: 10,
  DoCreateSuppliers: true,
  DoFillOpeningHours: true,
  DoCreateAdministration: true,
  DoCreateRevenueGroups: true,
  DoCreateSMSProvider: true,
  DoCreateRDWServiceProvider: true,
  DoSetInvoiceLayout: true,
  DoFillSundries: true,
  AmountOfWorkorders: 80,
  TotalAmountOfInvoices: 50,
  AmountOfCreditedInvoices: 20,
  AmountOfLinesPerWorkorder: 5,
  AmountOfWorkorderActivities: 10,
  AmountOfEmployees: 20,
  AmountOfEmployeeSkills: 10,
  AmountOfStockParts: 150,
  AmountOfPartGroups: 20,
  VehicleSalesInvoicePeriodStartDate: moment().subtract(6, 'month').toISOString(),
  VehicleSalesInvoicePeriodEndDate: moment().toISOString()
}

export const DefaultSeedAccountancyDataCreateInput: SeedDataAccountancyCreateInputType = {
  SkipWorkStations: true,
  SkipWorkHours: true,
  SkipPaymentOptions: true,
  SkipSundries: true,
  SkipVehicleSaleCategories: true,
  AdministrationUUID: ''
}
